<template>
    
    <div class="ccpay-orderSates"  style="height:100%" >
        <iframe v-show="playflag" src = "https://ccpaycommonfile.s3.ap-northeast-1.amazonaws.com/voice/order_voice_notify.mp3" hidden="true" allow = "autoplay"/>
        <div class="ccpay-order-tab">
            <div @click="changeActive(1,'pedding')"><span :class="isactive==1?'class-tab-sp':''" >进行中&nbsp;{{isactive==1?data&&data.length:''}}</span></div>
            <div @click="changeActive(2,'ended')"><span :class="isactive==2?'class-tab-sp':''">已完成&nbsp;{{isactive==2?data&&data.length:''}}</span></div>
            <div @click="changeActive(3,'cancel')"><span :class="isactive==3?'class-tab-sp':''">已取消&nbsp;{{isactive==3?data&&data.length:''}}</span></div>
        </div>
        <div style="height:3rem" ></div>
          <!-- 需要一个创建一个父容器 组件高度默认等于父容器的高度 -->
           <mt-loadmore :top-method="loadTop"   ref="loadmore" style="background:white">
               <div class="ccpay-order-content" style="height:auto;flex:1">
              <mt-search
                style="height:60px"
                v-show="state!='pedding'"
                v-model="searchvalue"
                cancel-text="取消"
                placeholder="搜索"
                >
                </mt-search>
                <div class="selectTime" 
                    v-show="state!='pedding'"
                    @click="selectData">
                    <span >选择开始时间：</span>
                    <span>{{this.selectedValue}}</span>
                 </div>
                <div class="selectTime" 
                    v-show="state!='pedding'"
                    @click="selectData2">
                    <span >选择结束时间：</span>
                    <span>{{this.selectedValue2}}</span>
                 </div>
                 <mt-button  v-show="state!='pedding'" type="primary" style="marginBottom:10px" @click="search()"  >查询</mt-button>
               <div class="ccapy-order-card" v-for='(item,index) in data' :key="index" @click="detail(item.order_no)">
                   <div class="ccpay-cls-act-div" v-show="item.isclass"></div>
                    <p class="ccpay-order-card-hed fz14"><span>
                        <span class="c-r-c-g fw-60"  :style="{'color':item.side=='BUY'?'#54BCA5':'#CA595B'}" style="margin-right">
                        {{item.side=='BUY'?'买-' + item.kyc_name :'卖-' + item.kyc_name }} </span>
                        </span>
                        <span class=" c-r-c-g" v-show="item.status=='CREATED'&&item.side=='BUY'">未付款</span>
                        <span class="c-r-c-g fw-60" v-show="item.status=='PAID'" >已付款</span>
                        <span class="c-r-c-g fw-60" v-show="item.status=='COMPLETE'&&item.side=='BUY'">已完成</span>
                        <span class="c-r-c-g fw-60" v-show="item.status=='RECIVED'&&item.side=='BUY'">已完成</span>
                        <span class="c-r-c-g fw-60" v-show="item.status=='CANCEL'&&item.side=='BUY'">已取消</span>

                        <span class="c-r-c-br " v-show="item.status=='CREATED'&&item.side=='SELL'">去付款</span>
                        <span class="c-r-c-br fw-60" v-show="item.status=='COMPLETE'&&item.side=='SELL'">已完成</span>
                        <span class="c-r-c-br fw-60" v-show="item.status=='RECIVED'&&item.side=='SELL'">已完成</span>
                        <span class="c-r-c-br fw-60" v-show="item.status=='CANCEL'&&item.side=='SELL'">已取消</span>
                    </p>
                    <p class="ccpay-order-c-spbed fz14" ><span>{{moment(item.created_time).format("MM-DD HH:mm")}}</span><span v-show="isactive==1">{{dataArr.length>0?dataArr[index]:''}}  </span></p>
                    <p class="ccpay-order-c-spbed fz14"><span>{{parseFloat(Number(item.traders_count))  }} USDT</span><span style="float:right">{{toFixed(item.trader_price,2) }}</span></p>
                    <p class="ccpay-order-c-spbed fz14"    >
                      <span>¥ {{toFixed(item.legal_amount,2)}}</span>
                         <button class="ccpay-order-c-canle fz14" 
                            style="outline: none;" 
                            v-show="item.side=='BUY'&&item.status=='PAID'"
                            type="default">放行</button>
                              <button class="ccpay-order-c-canle fz14" 
                              v-show="item.side=='SELL'&&item.status=='CREATED'"
                            type="default" 
                            style="outline: none;"
                          >去付款</button>
                    </p>
                    
            </div>
            <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker"
                v-model="dateVal"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm()">
            </mt-datetime-picker>
             </div>
             <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker2"
                v-model="dateVal2"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm2()">
            </mt-datetime-picker>
             </div>
            </div>
            <div style=" padding-bottom: 5rem;">
             <Scroll
                style=" padding-top: 1rem;"
                v-show="data.length>0&&state!='pedding'"
                @timer="timer"
                :moreTit="bottomText"
                ref="mychild"
            />
               
             </div>
         </mt-loadmore>
    </div>
   
</template>

<script>
import {toFixed} from '../../public/index.js'
import Scroll from "@/component/scroll";
import moment from  "moment"
import {Indicator, Loadmore} from 'mint-ui';
export default {
    components:{
        Scroll
    },
    watch:{
        data(newName,oldName){
            this.data = newName
        }
    },
    data(){
        return {
            searchvalue:'',
            dataArr:[],
            popupVisible:true,
            audio: {
                // 该字段是音频是否处于播放状态的属性
                playing: false
            },
            moreTit: "加载更多",
            isTabpadding:true,//tab切换
            isactive:1,
            curPage: 1,
            bottomText: '上拉加载更多...',
            data:[],
            state:'pedding',
            audiotimer:null,
            playflag:false,
            restTimer:null,//订单倒计时
            restStr:'',
            per_page:'1000',
             dateVal: '', // 默认是当前日期
            selectedValue: '',
             dateVal2: '', // 默认是当前日期
            selectedValue2: '',
        }
    },
    mounted(){
        
        // console.log(document.getElementById('ccpayaudio').play())
       
        this.onPullingDown()
       
        this.audiotimelist()
    },
   
    destroyed(){
    
         this.$ModelToast(false)
         clearInterval(this.audiotimer)
       
         clearInterval(this.restTimer)
    },
    methods:{
        loadTop() {
            setTimeout(()=>{
                  this.onPullingDown()
                  this.$refs.loadmore.onTopLoaded();
                  this.bottomText= '加载更多'
                  this.$refs.mychild.get();
            },1000)
         
        },
      
        toFixed,
        moment,
        play(){
           this.playflag = !this.playflag
        },
         // 当音频播放
        audiotimelist(){
          
            this.audiotimer = setInterval(()=>{
                this.$axios.get(`/v1/traders/order/list/pedding?page=1&per_page=1000&order=0`).then(res=>{
                 if(res.code==0){
                    //  console.log(res.data.length>0,'res.data.length')
                    if(this.state=='pedding'){
                       
                     if(res.data.length>0){
                            let important = []
                           let noimportant = []
                           res.data.forEach((item,index)=>{
                               if(item.side=='BUY'){
                                   if(item.status=='PAID'){
                                       important.push(item)
                                   }else{
                                       noimportant.push(item)
                                   }
                               }else{
                                    important.push(item)
                               }
                            })
                            noimportant.forEach((item,index)=>{
                                important.push(item)
                            })
                             this.data = important

                        // this.data = res.data
                        this.isclassId(this.data)
                        let neworder_no =    moment(res.data[0].created_time).valueOf()
                        // let neworder_no2 =    moment(res.data[1].created_time).valueOf()
                        let order_no = window.localStorage.getItem('order_no')
                      
                        if(order_no){
                            //  console.log(neworder_no>Number(order_no),neworder_no,Number(order_no))
                            if(neworder_no>Number(order_no)){
                                this.$ModelToast(true)
                                this.playflag = true
                                window.localStorage.setItem('order_no',neworder_no)
                                setTimeout(() => {
                                    this.playflag = false
                                }, 4000);
                            }
                           
                        }else{
                            this.$ModelToast(true)
                             this.playflag = true
                             window.localStorage.setItem('order_no',neworder_no)
                            setTimeout(() => {
                                  this.playflag = false
                            }, 4000);
                        }
                        // if(neworder_no!==order_no){
                        //     this.$ModelToast(true)
                        //      console.log('xindingdan')
                        //     this.playflag = true
                        //     window.localStorage.setItem('order_no',res.data[0].order_no)
                        //     setTimeout(() => {
                        //           this.playflag = false
                        //     }, 4000);
                        // }else{
                            
                        // }
                      }
                       }
                    //   console.log(res.data[0].order_no,'刷新哦')
                    //  console.log(res.data)
                 }
                 })
            },10000)
        },
      
          // 初始化数据
        onPullingDown(){
            Indicator.open();
            this.curPage = 1
             this.$axios.get(`/v1/traders/order/list/${this.state}?page=1&per_page=${this.per_page}&order=0`).then(res=>{
                 Indicator.close();
                 if(res.code==0){
                     if(this.state=='pedding'){
                           let important = []
                           let noimportant = []
                           res.data.forEach((item,index)=>{
                               if(item.side=='BUY'){
                                   if(item.status=='PAID'){
                                       important.push(item)
                                   }else{
                                       noimportant.push(item)
                                   }
                               }else{
                                    important.push(item)
                               }
                            })
                            noimportant.forEach((item,index)=>{
                                important.push(item)
                            })
                             this.data = important
                             this.setIntervalTime()
                             this.isclassId(this.data)
                            // console.log(important,noimportant)
                     }else{
                          this.data = res.data
                     }
                 }
            })
        },
        setIntervalTime() {
         this.restTimer=    setInterval(() => {
             this.dataArr = []
            this.data.forEach(item => {
                this.dataArr.push(this.restTime(item.plan_end_time))
            //    item.residueTime = this.restTime(item.plan_end_time)
            })
            // this.data = data
            // console.log(this.dataArr)
              }, 1000)
        },
        restTime:function(time){
          
                 var settime = moment(time).valueOf()
                 var nowtime = moment().valueOf()
                
                 var restsec = settime - nowtime
                 
                 if(restsec<0){
                     return '已超时';
                 }
                //   console.log(restsec)
                 var minu = parseInt((restsec / (60 * 1000)) % 60);
                 var sec = parseInt((restsec / 1000) % 60);
                 return minu + ":" + this.zero(sec);
           
        },
        zero(sec) {
            if (sec < 10) {
                return "0" + sec;
            } else {
                return sec;
            }
        },
          timer(){
            if(this.state=='pedding'){
                return
            }
            this.bottomText= '正在加载...'
            this.onPullingUp()
        },
        //下拉加载
        onPullingUp(){
            this.curPage++
            this.$axios.get(`/v1/traders/order/list/${this.state}?page=${this.curPage}&per_page=10&order=0&keyword=${this.searchvalue}&start=${this.selectedValue}&end=${this.selectedValue2}`).then(res=>{
             let data = res.data
            //   console.log(res.data)
                if(res.code==0){
                   if(data.length==0){
                        this.bottomText= '暂时没有了'
                       this.$refs.mychild.gets();
                   }else{
                       this.bottomText= '加载更多'
                       this.data = this.data.concat(res.data);
                        if(this.state=='pedding'){
                          this.isclassId(this.data)
                        }
                       this.$refs.mychild.get();
                   }
               }
            })
       
        },
        //切换状态
        changeActive(type,state){
            if(type==1){
                // this.audiotimelist()
                this.per_page = '1000'
            }else{
                this.per_page = '10'
                 this.$ModelToast(false)
                // clearInterval(this.audiotimer)
                clearInterval(this.restTimer)
            }
            this.bottomText= '加载更多'
            this.isactive = type
            this.curPage = 1
            this.state = state
            this.onPullingDown()
            if(this.$refs.mychild){
                 this.$refs.mychild.get();
            }
        },
        //进入详情
        detail(id){
            let styList = window.localStorage.getItem('styList')
            if(!styList){
                let newarr = [id]
                window.localStorage.setItem('styList',JSON.stringify(newarr))
            }else{
                 let newlist = window.localStorage.getItem('styList')
                 let arr = JSON.parse(newlist)
                //    console.log(arr,'shi')
                 if(arr.indexOf(id)==-1){
                       arr.push(id)
                 }else{
                    //  console.log('问问哟')
                 }
                 window.localStorage.setItem('styList',JSON.stringify(arr))
            }
            // styList.push(id)
            this.$router.push({
                path:'/orderdetail',
                query:{orderid:id}
            })
        },
        //判断是否点击
        isclassId(data){
            let styList = JSON.parse(window.localStorage.getItem('styList'))
             if(!styList){
                styList = []
             }
            //  console.log(styList,'styList')
            data.forEach((item,index)=>{
            //    console.log(item)
                if(styList.indexOf(item.order_no)==-1){
                    item.isclass = true
                    // console.log('no')
                }else{
                    item.isclass = false
                    // console.log('yes')
                }
                
            })
        },
        search(){
            // console.log(this.searchvalue)
            
             this.curPage=1
            Indicator.open();
              this.$axios.get(`/v1/traders/order/list/${this.state}?page=1&per_page=${this.per_page}&order=0&keyword=${this.searchvalue}&start=${this.selectedValue}&end=${this.selectedValue2}`).then(res=>{
                 Indicator.close();
                 if(res.code==0){
                     if(this.$refs.mychild){
                        this.$refs.mychild.get();
                    }
                     this.data = res.data
                 }
              })
        },
        selectData () { // 打开时间选择器
            // 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.selectedValue) {
                this.dateVal = this.selectedValue
            } else {
                this.dateVal = new Date()
            }
            this.$refs['datePicker'].open()
        },
        dateConfirm () { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.selectedValue = moment(this.dateVal).format("YYYY-MM-DD HH:SS")
        },
        selectData2 () { // 打开时间选择器
            // 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.selectedValue2) {
                this.dateVal2 = this.selectedValue2
            } else {
                this.dateVal2 = new Date()
            }
            this.$refs['datePicker2'].open()
        },
        dateConfirm2 () { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.selectedValue2 = moment(this.dateVal2).format("YYYY-MM-DD HH:SS")
        },
    }
}
</script>

<style lang="scss" scoped>
    .selectTime{
        margin:10px;
    }
    .fw-60{
        font-weight:600;
    }
    .ccpay-orderSates{
        
        .ccpay-cls-act-div{
                // border-radius: 2rem;
                //   border-radius: 8px;
                position: absolute;
                width: 100%;
                height: 100%;
                background: cornflowerblue;
                opacity: 0.1;
                top: 0;
                left: 0;
        }
       
        // background: #F8F8F8;
        // padding-bottom: 40px;
        // position: relative;
            // overflow: hidden;
        .ccpay-order-header{
            
            background: white;
            // margin-top: 2.5rem;
            padding: 1rem;
            // margin-bottom: 2rem;
            display: flex;
            align-items: center;
            // justify-content: space-around;
            div{
                // display: inline-block;
                margin-right: 1rem;
                color:#999;
            }
            .class-tab{
                font-size: 1.5rem;
                color:black;
                position: relative;
                span{
                     position: absolute;
                    font-size: 1.5rem;
                    left: 50%;
                    width: 1rem;
                    height: 2px;
                    background: black;
                    bottom: -0.625rem;
                    margin-left: -0.5rem;
                }
            }
        }
        .ccpay-order-tab{
            font-weight: 500;
             position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            // padding: 1rem;
            background: white;
            display: flex;
            // padding-left:2rem;
            justify-content: space-around;
            border-bottom:1px solid #ccc;
            padding-bottom:0.2rem;
            div{
                // flex: 1;
                // margin-right: 3rem;
                text-align: center;
                .class-tab-sp{
                    background: #20ABFE;
                    padding: 8px;
                    padding-left: 16px;
                    padding-right: 16px;
                    color: white;
                    font-size: 14px;
                    border-radius: 10px;
                    
                }
            }
            // justify-content: space-between;
        }
        .ccpay-order-content{
            padding:1rem;
            padding-bottom: 0;
        }
        .ccapy-order-card{
            color: #666666;
            // margin-top: 24px;
            // margin-bottom: 2rem;
            -webkit-transform: translateZ(0px);
            transform: translateZ(0px);
            font-size: 14px;
            -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // border-radius: 8px;
            // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
            border-bottom: 1px solid #ccc;
            position: relative;
            padding: 1.5rem;
            padding-bottom: 0.01rem;
            p{
                margin-bottom: 1rem;
                // span:nth-of-type(1){
                //     font-weight: 500;
                // }
            }
           .ccpay-order-card-hed{
                display: flex;
                // padding-top: 1rem;
                // padding-bottom: 1rem;
                // border-bottom: 1px solid;
                justify-content: space-between;
                span{
                    // margin-right: .8rem;
                    font-size: 0.9rem;
                    // font-size: 1rem;
                }
                .c-o-bg-r{
                    color: #E08DA1;
                    background: #FFF7FA;
                    padding: 7px;
                    border-radius: 10px;
                }
                .c-r-c-g{
                    color: #54BCA5;
                    
                }
                .c-r-c-b{
                    color:black;
                }
                .c-r-c-br{
                    color:#CA595B;
                    margin-right: 0;
                    font-weight: 600;
                }
           }
            background: white;
            .ccpay-order-c-spbed{
                display: flex;
                justify-content: space-between;
            }
            .ccpay-order-c-canle{
                background: #20ABFE;
                padding: 6px;
                border: none;
                padding-left: 1rem;
                padding-right: 1rem;
                color: white;
                border-radius: 2px;
            }
        }
          .position-box {
                position: absolute;
                top: 40px;
                left: 0;
                right: 0;
                bottom: 0;
        }
    }
  
</style>



// WEBPACK FOOTER //
// src/components/index/OrderStates.vue